import { useEffect, useState } from 'react';
import { GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import { asyncGetAccountAcceptsHabeasDataHistory } from '../../../../../../services/accounts.service';
import { AccountHabeasDataHistory } from '../../../../../../shared/types/modules/account';
import { TableTooltip } from '../../../../../components/general/table';
import DateTimeFormat from '../../../../../components/dateTimeFormat';

export const useAccountHabeasDataHistory = () => {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<AccountHabeasDataHistory[]>([]);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [total, setTotal] = useState<number>(0);

    const paginator = (model: GridPaginationModel) => {
        if (model.page !== page) {
            setPage(model.page);
        } else if (model.pageSize !== pageSize) {
            setPageSize(model.pageSize);
        }
    };

    const columns: GridColDef<AccountHabeasDataHistory>[] = [
        {
            field: 'created_at',
            headerName: 'Fecha de creación',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => <DateTimeFormat dateAt={row.row.created_at} />,
        },
        {
            field: 'value',
            headerName: 'Valor',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <>
                    {row.row.changes.contactType.acceptsHabeasData
                        ? 'Si'
                        : 'No'}
                </>
            ),
        },
        {
            field: 'createdBy',
            headerName: 'Modificado por',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip value={row.row.createdBy?.username || ''} />
            ),
        },
    ];

    useEffect(() => {
        setLoading(true);
        asyncGetAccountAcceptsHabeasDataHistory(page, pageSize)
            .then((res) => {
                setRows(res.items);
                setTotal(res.length);
            })
            .finally(() => setLoading(false));
    }, [page, pageSize]);

    return {
        columns,
        rows,
        page,
        pageSize,
        paginator,
        loading,
        total,
    };
};
